import { createFileRoute } from "@tanstack/react-router";
import { RelatorioReferencia } from "pages/relatorios/pages/referencia";

export const Route = createFileRoute("/a/relatorios/referencia")({
	component: RelatorioReferencia,
});
